import axios, { AxiosError } from "axios"
import { Environment } from "./envirmoent"

export interface AuthUserObject {
    readonly username: string,
    readonly token: string,
}

class AuthUserService {
    readonly enpoint = `${Environment.environment.baseUrl}auth/login`

    login = async (username: string, password: string): Promise<AuthUserObject | never> => {
        try {
            const result = await axios.post(this.enpoint, {
                username,
                password
            })

            return result.data as AuthUserObject
        } catch (e) {
            if (axios.isAxiosError(e)) {
                throw new Error(e.response?.data.error)
            } else {
                throw e
            }
        }
    }
}

export default AuthUserService